import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import AuthenticatedRouter from '../Router/AuthenticatedRouter';
import SettingMainPage from './SettingMainPage';

class SettingPage extends Component {
    render() {
        return (
            <Switch>
                <AuthenticatedRouter exact path="/settings" component={SettingMainPage} />
            </Switch>
        )
    }
};

export default SettingPage;